import type { CapacityStatus } from '@obraplan/core/domain/planning/capacity-calculator';
import type { BoardCell } from '@obraplan/core/domain/planning/weekly-board';

/** Cor e peso do texto por situação de capacidade — a cor nunca vai sozinha. */
export const CELL_TONE: Readonly<Record<CapacityStatus, string>> = {
  WITHIN: '',
  AT_LIMIT: 'text-(--color-state-warn)',
  EXCEEDED: 'text-(--color-state-danger) font-semibold',
  UNLIMITED: 'text-(--color-content-muted)',
};

/** A soma das metas dos dias — a meta da semana é projeção, não um segundo número. */
export function formatTotalQuantity(
  activityRow: { cells: readonly BoardCell[] },
  decimals: number,
): string {
  const total = activityRow.cells.reduce(
    (sum, cell) => sum + (cell.allocation?.plannedQuantity ?? 0),
    0,
  );
  if (total === 0) return '—';
  return total.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
